import React, { Component } from "react";
import UserList from './UserList'
import Config from './Config'
 
class Customer extends Component {
  
  render() {
    return (
      <UserList config={Config.customer}/>
    );
  }
}
 
export default Customer;


// WEBPACK FOOTER //
// ./src/js/Customer.js